import React from "react";
/**
 * Render a `select` element.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Select(props) {
    return React.createElement("select", { ...props });
}
//# sourceMappingURL=Select.js.map